import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import {
  SETTLEMENTS_REPORT_LOADINGS,
  reportSettlementsTypes,
} from "redux/reducers/Reports/reportSettlements/types";

const { SET_SETTLEMENTS_REPORT_FILTERS } = reportSettlementsTypes;
const { GET_REPORT } = SETTLEMENTS_REPORT_LOADINGS;

export const getSettlementsReportAction = (
  { startDate, endDate, station, isPdf }
) => async (dispatch, getState) => {
  const token = getState().login.token || localStorage.getItem("crm-user");
  const params = {
    start: startDate,
    end: endDate,
    idStation: station.id,
    pdf: isPdf,
  };
  dispatch(startRequestComp(GET_REPORT));
  try {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/user-sales/report`;
    const res = await axios.get(url, {
      headers: { authorization: token },
      responseType: "blob",
      params,
    });

    const format = isPdf ? "pdf" : "xlsx";
    saveAs(res.data, `Reporte_liquidaciones_${station.name}_${startDate}_${endDate}.${format}`);
    dispatch(setSnackbar("Reporte descargado con éxito", "success"));
  } catch (err) {
    dispatch(setSnackbar(await getErrorBlob(err)));
  } finally {
    dispatch(stopRequestComp(GET_REPORT));
  }
};

export const setSettlementsReportFilters = (key = "", value) => ({
  type: SET_SETTLEMENTS_REPORT_FILTERS,
  payload: { key, value }
});
